import { formatDistanceToNow, parseISO, fromUnixTime } from "date-fns";

export function getDateFromNow(date: string | number) {
  const x =
    typeof date === "string" ? parseISO(date) : fromUnixTime(date / 1000);
  return formatDistanceToNow(x, { addSuffix: true });
}
